// Module
var code = "<div class=\"progress {{outerClass}} {{valueClass.outter}}\"> <div class=\"{{valueClass.inner}} {{innerClass}}\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width : ( value + '%' ) }\" style=\"width:100%\"> <span class=\"sr-only\">{{value}}%</span> </div> </div>";
// Exports
export default code;